var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1668_59207)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3903 10.3903C10.8366 9.944 11.5602 9.944 12.0066 10.3903L15.9984 14.3822L19.9903 10.3903C20.4366 9.944 21.1602 9.944 21.6066 10.3903C22.0529 10.8366 22.0529 11.5602 21.6066 12.0066L17.6147 15.9984L21.6066 19.9903C22.0529 20.4366 22.0529 21.1602 21.6066 21.6066C21.1602 22.0529 20.4366 22.0529 19.9903 21.6066L15.9984 17.6147L12.0066 21.6066C11.5602 22.0529 10.8366 22.0529 10.3903 21.6066C9.944 21.1602 9.944 20.4366 10.3903 19.9903L14.3822 15.9984L10.3903 12.0066C9.944 11.5602 9.944 10.8366 10.3903 10.3903Z",
    fill: "#f14242"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 29.7143C23.5742 29.7143 29.7143 23.5742 29.7143 16C29.7143 8.42581 23.5742 2.28571 16 2.28571C8.42581 2.28571 2.28571 8.42581 2.28571 16C2.28571 23.5742 8.42581 29.7143 16 29.7143ZM32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16Z",
    fill: "#f14242"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1668_59207"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.17b2ebd558dec604f19db7c119e56b8a.svg";
export { ForwardRef as ReactComponent };